exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--2rlnc {\n  color: #FFFFFF;\n  margin: 10px;\n  padding-bottom: 5px;\n  border-bottom: 1px dashed #5d5d5d;\n}\n\n.wrapper--2rlnc .phone--3MNyv {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 23px;\n}\n\n.wrapper--2rlnc .phone--3MNyv .call-icon--2GXdr {\n  height: 100%;\n  margin-left: 10px;\n  fill: #8cc84d;\n  stroke: #8cc84d;\n  -webkit-transform: scale3d(1.1, 1.1, 1.1);\n          transform: scale3d(1.1, 1.1, 1.1);\n}\n\n.wrapper--2rlnc .phone--3MNyv .number--2AM2o {\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 400;\n  padding: 0 10px;\n}\n\n.wrapper--2rlnc .name--XJhKA, .wrapper--2rlnc .not-found--1RKA- {\n  padding: 3px 5px 0 48px;\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 400;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--2rlnc",
	"phone": "phone--3MNyv",
	"call-icon": "call-icon--2GXdr",
	"number": "number--2AM2o",
	"name": "name--XJhKA",
	"not-found": "not-found--1RKA-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-client/side-menu/ClientsList/Call/Call.m.scss
// module id = 1461
// module chunks = 0